import { useEffect, useState } from "react";
import { get, post } from "../utils/fetch";
import { URL_ACEPTAR_TERMINOS } from "../constants/url";

export function useTerminos(estaLogueado) {
  const [loading, setLoading] = useState(true);
  const [aceptados, setAceptados] = useState(false);

  useEffect(() => {
    if (!estaLogueado) return;

    setLoading(true);
    get(URL_ACEPTAR_TERMINOS)
      .then((response) => {
        if (response.code === 0 && response.data?.fechaAceptacionTerminos) {
          setAceptados(true);
        } else if (response.code === 0) {
          setAceptados(false);
        } else {
          setAceptados(true);
        }
      })
      .catch(() => {
        setAceptados(true);
      })
      .finally(() => setLoading(false));
  }, [estaLogueado]);

  const aceptar = () => {
    post(URL_ACEPTAR_TERMINOS, {}).then((response) => {
      if (response.code === 0) {
        setAceptados(true);
      }
    });
  };

  return { loading, aceptados, aceptar };
}
